import React, { useRef, useState, useEffect } from 'react';
import { TTurbineProps } from '../../types';
import { StyledTableV5 } from 'components/DataTable/DataTable.style';
import { getTurbineColums } from './turbineColumns';

export function TurbinesList({
  containerHeight,
  data,
}: {
  containerHeight: number;
  data: Array<TTurbineProps>;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [scrollHeight, setScrollHeight] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (containerRef.current) {
      const parentHeight = containerRef.current.offsetHeight;
      const tableHeader = containerRef.current.querySelector('.ant-table-thead');
      const headerHeight = tableHeader?.clientHeight ?? 0;

      const maxBodyHeight = parentHeight - headerHeight;

      const tableBody = containerRef.current.querySelector('.ant-table-tbody');
      const bodyHeight = tableBody?.clientHeight ?? 0;

      if (bodyHeight > maxBodyHeight) {
        setScrollHeight(maxBodyHeight);
        return;
      }
      setScrollHeight(undefined);
    }
  }, [containerHeight, data]);

  const sortedData = React.useMemo(() => {
    return [...data].sort(
      (a, b) =>
        (b.inspectionData?.maxSeverity ?? -Infinity) - (a.inspectionData?.maxSeverity ?? -Infinity)
    );
  }, [data]);

  return (
    <div ref={containerRef} style={{ height: containerHeight }}>
      <StyledTableV5
        columns={getTurbineColums()}
        dataSource={sortedData}
        pagination={false}
        rowKey="key"
        size="middle"
        scroll={scrollHeight ? { y: scrollHeight } : undefined}
        tableLayout="fixed"
      />
    </div>
  );
}
